import React, { Component } from "react";
import {
  IsEmpty,
  markAsReadNotification,
  returnDate,
} from "../../util/commonFunctions";
import { Scrollbar } from "react-scrollbars-custom";
import { withRouter } from "react-router-dom";

class Notification extends Component {
  notificationClicked = (notification) => {
    if(notification.linkUrl) {
      window.open(notification.linkUrl);
    } else {
      location.href = "/";
    }
    markAsReadNotification(notification.id);
    notification.isRead = true;
  };

  notificationReadAll = () => {
    this.props.notification.filter((not) => {
      if (not.isRead == false) {
        markAsReadNotification(not.id);
        not.isRead = true;
      }
    });
  };

  fetchUserFriendlyDate = (notification) => {
    return returnDate(Date.parse(notification.date));
  };

  getUnreadNotificationCount = (allNotifications) => {
    return Object.entries(allNotifications).filter((n) => n[1].isRead === false)
      .length;
  };

  render() {
    let totalUnreadNotification = this.getUnreadNotificationCount(
      this.props.notification
    );
    return (
      <>
        <li className="header-notification">
          <span
            className="header-notification-toggler"
            onClick={() => this.props.toggleNotification(true)}
          >
            <img
              src={
                this.props.showNotification
                  ? "/assets/svg/notification-icon-open.svg"
                  : "/assets/svg/notification-icon.svg"
              }
            />
            {totalUnreadNotification > 0 && (
              <span className="notification-count">
                {totalUnreadNotification}
              </span>
            )}
          </span>
          {this.props.showNotification && (
            <div className="notification-block keepNotificationEnabled">
              <div className="notification-block-header keepNotificationEnabled">
                <h3 className="keepNotificationEnabled">NOTIFICATIONS</h3>
                <span
                  className={
                    IsEmpty(this.props.notification)
                      ? "hide"
                      : " keepNotificationEnabled"
                  }
                  onClick={() => this.notificationReadAll()}
                >
                  Mark all as read
                </span>
              </div>
              {IsEmpty(this.props.notification) && (
                <div className="notification-block-empty keepNotificationEnabled">
                  <img
                    className="keepNotificationEnabled"
                    src="/assets/svg/notification-empty-state.svg"
                  />
                  <h4 className="keepNotificationEnabled">No notifications</h4>
                  <p className="keepNotificationEnabled">
                    Check back later for notifications
                  </p>
                </div>
              )}
              {!IsEmpty(this.props.notification) && (
                <div className="notification-list-block">
                  <ul>
                    <Scrollbar>
                      {this.props?.notification.map((notification, key) => {
                        if (!notification.thumbnail || notification.thumbnail === ""){
                          notification.thumbnail = "/assets/ausbiz_series_logo.png";
                        }
                        return (
                          <li
                            key={key}
                            className={
                              notification.isRead
                                ? "notification-item"
                                : "notification-item breaking"
                            }
                            id={notification.id}
                            onClick={() => {
                              this.notificationClicked(notification);
                              this.props.toggleNotification(true);
                            }}
                          >
                            <div className="notification-item-img">
                              <img src={notification.thumbnail} />
                            </div>
                            <div className="notification-item-info">
                              <span
                                className={notification.isRead ? "" : "unread"}
                              >
                                {this.fetchUserFriendlyDate(notification)}
                              </span>
                              <h4>{notification.title}</h4>
                              <p>{notification.description}</p>
                              {/* <div className="notify-followed">Dominos Pizza</div> */}
                            </div>
                          </li>
                        );
                      })}
                    </Scrollbar>
                  </ul>
                </div>
              )}
            </div>
          )}
        </li>
      </>
    );
  }
}

export default withRouter(Notification);
